import React from "react";

export const getLightBars = () => {
  return [1, 2, 3].map((item) => <div key={item} className="lightBar"></div>);
};
